var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"dense":""}},_vm._l((_vm.docs),function(doc){return _c('v-col',{key:`doc_${doc.id}`,attrs:{"cols":"12"}},[_c('UIMediaDoc',{attrs:{"value":doc}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }